// import AppRoutes from "./routes/AppRoutes";

// export default function App() {
//   return <AppRoutes />;
// }


// src/App.js
import AppRoutes from "./routes/AppRoutes";
import { SiteContentProvider } from "./utils/SiteContentProvider"; // 👈 import the provider

export default function App() {
  return (
    <SiteContentProvider> {/* 👈 wrap all routes inside the provider */}
      <AppRoutes />
    </SiteContentProvider>
  );
}
